import { useCallback, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ACTIONS from '../../../redux/action';
import i18n from '../../../utils/i18n';
import Navigation from '../components/navigation/navigation';
import RadioInput from '../components/searchInputs/radioInput';
import {
	companyTypeFoundingInput,
	companyTypeInput,
} from '../data/searchFlowText';

const CompanyType = ({ ...props }) => {
	const companyStore = useSelector((state) => state.company_store);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const handleBack = useCallback(
		(decr) => {
			props.handleBack(decr);
		},
		[props]
	);

	const handleNext = useCallback(
		(e) => {
			props.handleNext(e);
		},
		[props]
	);

	const handleCompanyTypeChange = (value) => {
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'companytype',
				data: value,
				stateObject: 'company_store',
			})
		);
	};

	useEffect(() => {
		if (companyStore.legalentityfounding && companyStore.companytype === 'kft') {
			dispatch(
				ACTIONS.addCompanyInfo({
					id: 'reqFromBupa',
					data: false,
					stateObject: 'company_store',
				})
			);
			dispatch(
				ACTIONS.addCompanyInfo({
					id: 'callbacksource',
					data: 'regkftrequest',
					stateObject: 'company_store',
				})
			);
			dispatch(
				ACTIONS.addCompanyInfo({
					id: 'leadtype',
					data: 'KFTREG',
					stateObject: 'company_store',
				})
			);
			dispatch(
				ACTIONS.addCompanyInfo({
					id: 'flowStart',
					data: 'KFTREG',
					stateObject: 'company_store',
				})
			);
			dispatch(
				ACTIONS.addCompanyInfo({
					id: 'isCallBackReq',
					data: false,
					stateObject: 'company_store',
				})
			);
		}
	}, [companyStore.legalentityfounding, companyStore.companytype, dispatch]);

	return (
		<div className="stepContainer">
			<div className="SFInput">
				<p className="SFSubTitle">
					<span className="SFSubTitle">{i18n.t('company.companyform')}</span>{' '}
					<span className="questionTracker">1/8</span>
				</p>
				{companyStore.legalentityfounding ? (
					<RadioInput
						storeID="companytype"
						dataText={companyTypeFoundingInput()}
						onChange={handleCompanyTypeChange}
					/>
				) : (
					<RadioInput
						storeID="companytype"
						dataText={companyTypeInput()}
						onChange={handleCompanyTypeChange}
					/>
				)}
			</div>
			<Navigation
				step={2}
				handleBack={() => handleBack(2)}
				handleNext={() => {
					if (companyStore.companytype === 'kft' &&
						companyStore.newlyfounded) {
						navigate('/company/request/kftreg');
					} else if (
						companyStore.companytype === 'kft' &&
						!companyStore.newlyfounded
					) {
						handleNext(1);
					} else {
						handleNext(2);
					}
				}}
				openHelpForm={() => props.openHelpForm()}
				disabledProp={companyStore.companytype === '' ? true : false}
			/>
		</div>
	);
};

export default withTranslation()(CompanyType);
